/* ============================================================
   NOVEL THEME - global.js
   Menu drawer, cart drawer, free gifts, product form,
   bundle offers, gallery, sticky ATC.
   ============================================================ */

(function () {
  'use strict';

  var routes = {
    cartAdd: window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js',
    cartChange: window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/change.js' : '/cart/change.js',
    cartUpdate: window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/update.js' : '/cart/update.js',
    cart: window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js'
  };

  function money(cents) {
    var format = (window.themeSettings && window.themeSettings.moneyFormat) || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    return format.replace(/\{\{\s*amount[^}]*\}\}/, amount);
  }

  /* ---------- Menu drawer ---------- */
  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-menu-open]');
    var closeEl = e.target.closest('[data-menu-close]');
    var drawer = document.getElementById('MenuDrawer');
    if (!drawer) return;
    if (openBtn) { drawer.setAttribute('open', ''); document.body.style.overflow = 'hidden'; }
    if (closeEl) { drawer.removeAttribute('open'); document.body.style.overflow = ''; }
  });

  /* ---------- Free gifts ----------
     One rule: as soon as the cart holds at least one paid line,
     every gift variant is forced to quantity 1. No paid line,
     no gifts. Quantity of the paid product is irrelevant. */
  var gifts = {
    syncing: false,
    ids: function () {
      var el = document.getElementById('CartDrawer');
      var raw = el && el.dataset.giftVariants;
      if (!raw) return [];
      return raw.split(',').map(function (v) { return parseInt(v, 10); }).filter(function (v) { return !!v; });
    },
    isGift: function (variantId) {
      return this.ids().indexOf(variantId) !== -1;
    },
    /* Resolves with { cart: cart, changed: bool } */
    sync: function (cart) {
      var self = this;
      var ids = this.ids();
      if (!ids.length || this.syncing) return Promise.resolve({ cart: cart, changed: false });

      var qualifies = cart.items.some(function (item) {
        return ids.indexOf(item.variant_id) === -1 && item.final_price > 0;
      });

      var updates = {};
      var changed = false;
      ids.forEach(function (id) {
        var current = 0;
        cart.items.forEach(function (item) {
          if (item.variant_id === id) current += item.quantity;
        });
        var target = qualifies ? 1 : 0;
        if (current !== target) { updates[id] = target; changed = true; }
      });

      if (!changed) return Promise.resolve({ cart: cart, changed: false });

      this.syncing = true;
      return fetch(routes.cartUpdate, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates })
      })
        .then(function (r) { return r.json(); })
        .then(function (fresh) {
          self.syncing = false;
          return { cart: fresh, changed: true };
        })
        .catch(function (err) {
          self.syncing = false;
          console.error('Gift sync failed', err);
          return { cart: cart, changed: false };
        });
    }
  };
  window.cartGifts = gifts;

  /* ---------- Cart drawer ---------- */
  var cartDrawer = {
    el: function () { return document.getElementById('CartDrawer'); },
    open: function () {
      var el = this.el();
      if (!el) return;
      el.classList.add('active');
      el.removeAttribute('aria-hidden');
      document.body.style.overflow = 'hidden';
    },
    close: function () {
      var el = this.el();
      if (!el) return;
      el.classList.remove('active');
      el.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    },
    renderMarkup: function () {
      var self = this;
      return fetch(window.location.pathname + '?section_id=cart-drawer')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.getElementById('CartDrawer');
          var current = self.el();
          if (fresh && current) {
            var wasActive = current.classList.contains('active');
            current.innerHTML = fresh.innerHTML;
            if (wasActive) current.classList.add('active');
          }
        });
    },
    updateCount: function (cart) {
      var count = 0;
      cart.items.forEach(function (item) {
        if (!gifts.isGift(item.variant_id)) count += item.quantity;
      });
      document.querySelectorAll('[data-cart-count]').forEach(function (b) {
        b.textContent = count;
        b.classList.toggle('hidden', count === 0);
      });
    },
    refresh: function (openAfter) {
      var self = this;
      return fetch(routes.cart)
        .then(function (r) { return r.json(); })
        .then(function (cart) { return gifts.sync(cart); })
        .then(function (result) {
          return self.renderMarkup().then(function () { return result.cart; });
        })
        .then(function (cart) {
          self.updateCount(cart);
          if (openAfter) self.open();
        })
        .catch(function (err) { console.error('Cart refresh failed', err); });
    },
    change: function (line, quantity) {
      var self = this;
      return fetch(routes.cartChange, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      }).then(function () { return self.refresh(false); });
    }
  };
  window.cartDrawer = cartDrawer;

  /* Gifts must be right even if the drawer is never opened:
     sync once on load, and reload the cart page if it changed. */
  function initialGiftSync() {
    if (!gifts.ids().length) return;
    fetch(routes.cart)
      .then(function (r) { return r.json(); })
      .then(function (cart) { return gifts.sync(cart); })
      .then(function (result) {
        if (!result.changed) return;
        if (document.body.classList.contains('template-cart')) {
          window.location.reload();
          return;
        }
        cartDrawer.renderMarkup().then(function () { cartDrawer.updateCount(result.cart); });
      })
      .catch(function (err) { console.error('Gift sync failed', err); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialGiftSync);
  } else {
    initialGiftSync();
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-open]')) {
      if (window.themeSettings && window.themeSettings.cartType === 'drawer') {
        e.preventDefault();
        cartDrawer.refresh(true);
      }
    }
    if (e.target.closest('[data-cart-close]')) { e.preventDefault(); cartDrawer.close(); }

    var removeBtn = e.target.closest('[data-cart-remove]');
    if (removeBtn) {
      e.preventDefault();
      cartDrawer.change(parseInt(removeBtn.dataset.cartRemove, 10), 0);
    }

    var qtyBtn = e.target.closest('[data-qty-change]');
    if (qtyBtn) {
      var wrapper = qtyBtn.closest('.quantity');
      var input = wrapper.querySelector('input');
      var delta = qtyBtn.dataset.qtyChange === 'plus' ? 1 : -1;
      var newVal = Math.max(parseInt(input.value || '1', 10) + delta, parseInt(input.min || '0', 10) || 0);
      input.value = newVal;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      var line = input.dataset.line;
      if (line) cartDrawer.change(parseInt(line, 10), newVal);
    }
  });

  /* ---------- Product form (AJAX add to cart) ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-product-form]');
    if (!form) return;
    if (!window.themeSettings || window.themeSettings.cartType !== 'drawer') return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var originalText = btn ? btn.innerHTML : '';
    if (btn) { btn.setAttribute('disabled', ''); btn.innerHTML = '<span class="atc-label">' + (btn.dataset.addingText || 'Adding') + '</span>'; }

    fetch(routes.cartAdd, { method: 'POST', body: new FormData(form) })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status && data.status !== 200) throw new Error(data.description || 'Error');
        return cartDrawer.refresh(true);
      })
      .catch(function (err) { alert(err.message); })
      .finally(function () {
        if (btn) { btn.removeAttribute('disabled'); btn.innerHTML = originalText; }
      });
  });

  /* ---------- Product gallery ---------- */
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-gallery-thumb]');
    if (!thumb) return;
    var gallery = thumb.closest('[data-gallery]');
    var main = gallery.querySelector('[data-gallery-main] img');
    var src = thumb.dataset.gallerySrc;
    if (main && src) main.src = src;
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.classList.remove('active'); });
    thumb.classList.add('active');
  });

  /* ---------- Sticky ATC ---------- */
  var stickyBar = document.querySelector('[data-sticky-atc]');
  var mainAtc = document.querySelector('[data-main-atc]');
  if (stickyBar && mainAtc && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      stickyBar.classList.toggle('visible', !entries[0].isIntersecting);
    }, { threshold: 0 }).observe(mainAtc);

    var stickyBtn = stickyBar.querySelector('[data-sticky-submit]');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        var form = document.querySelector('form[data-product-form]');
        if (form) form.requestSubmit();
      });
    }
  }

  /* ---------- Bundle offers (variant driven) ----------
     Every offer maps to a real variant. No client side maths:
     the price shown is the variant price, so cart never diverges. */
  document.querySelectorAll('[data-product-section]').forEach(function (sectionEl) {
    var form = sectionEl.querySelector('form[data-product-form]');
    if (!form) return;

    var atcIcon = '';
    var firstBtn = sectionEl.querySelector('[data-main-atc]');
    if (firstBtn) {
      var svgEl = firstBtn.querySelector('svg');
      if (svgEl) atcIcon = svgEl.outerHTML;
    }

    function apply() {
      var input = sectionEl.querySelector('[data-offers] input:checked');
      if (!input) return;
      var price = parseInt(input.dataset.offerPrice, 10) || 0;
      var compare = parseInt(input.dataset.offerCompare, 10) || 0;

      var idInput = form.querySelector('[name="id"]');
      if (idInput && input.dataset.offerVariant) idInput.value = input.dataset.offerVariant;
      var qtyInput = form.querySelector('[data-offer-qty-input]');
      if (qtyInput) qtyInput.value = 1;

      var btn = sectionEl.querySelector('[data-main-atc]');
      if (btn && !btn.hasAttribute('disabled') && btn.dataset.showPrice === 'true') {
        var html = atcIcon + '<span class="atc-label">' + (btn.dataset.defaultText || 'Add to cart') + '</span>';
        html += '<span class="atc-price">' + money(price) + '</span>';
        if (compare > price) html += '<s class="atc-compare">' + money(compare) + '</s>';
        btn.innerHTML = html;
      }

      var stickyPrice = document.querySelector('[data-sticky-price]');
      if (stickyPrice) stickyPrice.textContent = money(price);

      var url = new URL(window.location.href);
      url.searchParams.set('variant', input.dataset.offerVariant);
      window.history.replaceState({}, '', url.toString());
    }

    sectionEl.addEventListener('change', function (e) {
      var input = e.target.closest('[data-offers] input');
      if (!input) return;
      sectionEl.querySelectorAll('[data-offer]').forEach(function (l) { l.classList.remove('selected'); });
      var label = input.closest('[data-offer]');
      if (label) label.classList.add('selected');
      apply();
    });

    apply();
  });

  /* ---------- Delivery date estimate ---------- */
  document.querySelectorAll('[data-delivery-date]').forEach(function (el) {
    var minDays = parseInt(el.dataset.deliveryMin, 10) || 3;
    var maxDays = parseInt(el.dataset.deliveryMax, 10) || 6;
    var locale = document.documentElement.lang || 'en';
    var opts = { weekday: 'short', month: 'short', day: 'numeric' };
    function fmt(days) {
      var d = new Date();
      d.setDate(d.getDate() + days);
      return d.toLocaleDateString(locale, opts);
    }
    el.textContent = minDays === maxDays ? fmt(minDays) : fmt(minDays) + ' \u2013 ' + fmt(maxDays);
  });
})();
